import axios from "axios";

export default {
    async getAuditorias(params) {
        const config = {
            url: process.env.VUE_APP_BASE_API + "/auditoria",
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
                Authorization: localStorage.getItem("userToken"),
            },
            params: {
                page: params.page || 1,
                size: params.size || 20,
                id: params.id || undefined,
                metodo: params.metodo || undefined,
                statusCode: params.statusCode || undefined,
                statusCodeRange: params.statusCodeRange || undefined,
                url: params.url || undefined,
                fecha_desde: params.fecha_desde || undefined,
                fecha_hasta: params.fecha_hasta || undefined,
                id_usuario: params.id_usuario || undefined,
                nombre_usuario: params.nombre_usuario || undefined,
            },
        };
        const response = await axios(config);
        if (response.status === 200) {
            return response.data;
        } else {
            throw new Error(response.status);
        }
    },

    async getAuditoriaById(id) {
        const config = {
            url: `${process.env.VUE_APP_BASE_API}/auditoria/${id}`,
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
                Authorization: localStorage.getItem("userToken"),
            },
        };
        const response = await axios(config);
        if (response.status === 200) {
            return response.data;
        } else {
            throw new Error(response.status);
        }
    },
};
